import { Loader2 } from 'lucide-react';

/**
 * Neutral loading screen displayed while branding data is being fetched.
 *
 * This component acts as a "loading gate" — it prevents any route from
 * rendering (including the Login page) until we know whether the
 * organization slug is valid or not.
 *
 * Design constraints:
 * - No logo, product name, or brand colors (branding hasn't loaded yet)
 * - Neutral white background so it works for any white-label customer
 * - Centered spinner using Lucide's Loader2 icon
 * - Full viewport height to avoid layout shift
 */
export function BrandingLoadingScreen() {
  return (
    <div className="flex items-center justify-center min-h-screen bg-white">
      <Loader2 className="h-8 w-8 animate-spin text-gray-400" />
    </div>
  );
}
